import React from "react";
import { scroller } from "react-scroll";
import HeroVisual from "./HeroVisual";

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-noise" aria-hidden="true" />
      <div className="hero-grid" aria-hidden="true" />
      <div className="hero-glow hero-glow--a" />
      <div className="hero-glow hero-glow--b" />

      <div className="hero-content container">
        <div className="hero-left">
          <p className="hero-eyebrow">Dizajn softueri & inxhinieri</p>

          <h1 className="hero-title">
            Ndërtoni produkte që klientët tuaj{" "}
            <span className="hero-title-accent">u besojnë në çdo shkallë</span>
          </h1>

          <p className="hero-lead">
            TechTalent bashkëpunon me themelues dhe ekipe ndërmarrjesh për të projektuar,
            ndërtuar dhe hedhur në qarkullim platforma web dhe aplikacione mobile — me
            fushëveprim të qartë, përgjegjësi senior dhe dokumentacion që organizata juaj
            mund ta operojë vetë.
          </p>

          <ul className="hero-proof" aria-label="Standardet e dorëzimit">
            <li>Ekip të udhëhequr nga seniorë</li>
            <li>Pika kufitare &amp; demonstrime me shkrim</li>
            <li>Procese me ndërgjegje për sigurinë</li>
          </ul>

          <div className="hero-buttons">
            <button
              type="button"
              className="primary-btn"
              onClick={() =>
                scroller.scrollTo("contact", {
                  smooth: true,
                  duration: 550,
                  offset: -96,
                })
              }
            >
              Kërko një propozim
            </button>

            <button
              type="button"
              className="secondary-btn"
              onClick={() =>
                scroller.scrollTo("projects", {
                  smooth: true,
                  duration: 550,
                  offset: -96,
                })
              }
            >
              Shiko punët
            </button>
          </div>
        </div>

        <HeroVisual />
      </div>
    </section>
  );
}

export default Hero;
